import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import CampoFormulario from "../../components/CampoFormulario";
import { CAMPO_FECHA_PROPUESTA } from "../../model/campos";

const PasoFecha = ({ valores, errores, onChange }) => (
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Alert severity="info">
        Puedes proponer el día que mejor te quede. Biblioteca revisa su
        disponibilidad, define la fecha y la hora definitivas, que pueden ser
        distintas a la que elijas. Si lo dejas vacío, ellos te asignan una.
      </Alert>
    </Grid>

    <Grid item xs={12}>
      <CampoFormulario
        campo={CAMPO_FECHA_PROPUESTA}
        valor={valores[CAMPO_FECHA_PROPUESTA.name]}
        error={errores[CAMPO_FECHA_PROPUESTA.name]}
        onChange={onChange}
        ayuda="Opcional"
      />
    </Grid>
  </Grid>
);

PasoFecha.propTypes = {
  valores: PropTypes.object.isRequired,
  errores: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PasoFecha;
